import { Actions } from 'vuex-smart-module';
import CompaniesUsersGetters from './getters';
import CompaniesUsersMutations from './mutations';
import CompaniesUsersState from './state';

export default class CompaniesUsersActions extends Actions<
CompaniesUsersState,
CompaniesUsersGetters,
CompaniesUsersMutations,
CompaniesUsersActions
> {}
